export { default } from 'features/store/routes/autoselect-route';
